import { currentDevelopmentUIState } from './dev-ui-state';

export const getBoardIdForLocalDevelopment = () => {
  return currentDevelopmentUIState.boardId;
};
